import { useEffect } from 'react'
import { useSelector, useDispatch } from 'react-redux'
import type { RootState, AppDispatch } from '../store'
import { fetchCurrentUser } from '../slices/authSlice'
import { login } from './UserMenu'

interface RequireAuthProps {
  children: React.ReactNode
}

export default function RequireAuth({ children }: RequireAuthProps) {
  const dispatch = useDispatch<AppDispatch>()
  const { user, loading, checked, authError } = useSelector((state: RootState) => state.auth)

  useEffect(() => {
    if (!checked) {
      dispatch(fetchCurrentUser())
    }
  }, [dispatch, checked])

  useEffect(() => {
    if (checked && !loading && !user && !authError) {
      login(dispatch, window.location.pathname + window.location.search)
    }
  }, [dispatch, checked, loading, user, authError])

  if (!checked || loading) {
    return null
  }

  if (authError) {
    return (
      <div style={{ padding: '2rem', textAlign: 'center' }}>
        <p>Authentication service is temporarily unavailable. Please try refreshing the page.</p>
      </div>
    )
  }

  if (!user) {
    return null
  }

  return <>{children}</>
}
